// @flow
import React from 'react';
import type { Node } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
    label: {
        float: 'left'
    },
    value: {
        float: 'left'
    }
});

type Props = $ReadOnly<{
    label: Node,
    value: string
}>;
function Row({ label, value}: Props) {
    const classes = useStyles();

    return (
        <div>
            <div className={classes.label}>
                {label}
            </div>
            <div className={classes.value}>
                {value}
            </div>
        </div>
    );
}

export default Row;